const chatData = [
  {
    id: 0,
    bookId: 'BRNT-CCD1J3NNHS',
    title: 'Campbell Biology, 12e'
  },
  {
    id: 1,
    bookId: 'c357fd4c-bb16-4dea-b89b-99344b542f2b',
    title: 'Principles of Marketing, 18e'
  },
  {
    id: 2,
    bookId: 'BRNT-2YG2D663JN2',
    title: 'Chemistry A Molecular Approach,6e'
  },
  {
    id: 3,
    bookId: '545c066b-1630-4c04-9bd4-d8c26cd2e6f6',
    title: 'Principles of Marketing, 19e'
  }
  /* {
    id: 3,
    bookId: '4FHGBOUUFNS',
    title: 'Campbell Biology'
  },
  {
    id: 4,
    bookId: 'de7c2873-1039-4e69-b1c1-bcebb989d438',
    title: 'Accounting Information Systems'
  },
  {
    id: 5,
    bookId: 'aedd368b-2c3c-4df4-a3ab-d91031a9d57e',
    title: `Prebles' Artforms`
  },
  {
    id: 6,
    bookId: '3cd6d65b-8516-4693-a947-777bd04b07d5',
    title: 'Society: The Basics'
  },
  {
    id: 7,
    bookId: '1QQYQ88Y7KR',
    title: 'Business Analytics'
  },
  {
    id: 8,
    bookId: 'LDZIA769HJ',
    title: 'Emergency Care'
  },
  {
    id: 9,
    bookId: 'c9d42891-135e-4945-b3b2-71b0de230c3a',
    title: 'Using MIS'
  },
  {
    id: 10,
    bookId: '171638',
    title: 'Human Anatomy & Physiology Laboratory Manual, Fetal Pig Version'
  },
  {
    id: 11,
    bookId: '1bb6154d-297f-4066-be68-2adcef22cc65',
    title: 'Psychology'
  },
  {
    id: 12,
    bookId: 'BRNT-4TWXOYMS0MM',
    title: 'Starting out with Python'
  },
  {
    id: 13,
    bookId: '67d4445a-0ef4-4c2e-804f-cb92a87a06d4',
    title: 'Out of Many: A History of the American People'
  }
  {
    id: 14,
    bookId: '4dd9491b-dd0c-4da4-8275-4ae51821311e',
    title: 'Pearson eText for Starting Out With Python'
  } */
];

const feedBackTypesDropdownList = [
  {
    name: 'summary',
    label: 'Summary'
  },
  {
    name: 'discuss',
    label: 'Explain'
  },
  {
    name: 'quiz',
    label: 'Quiz'
  },
  {
    name: 'problem_solve',
    label: 'Problem Solve'
  },
  {
    name: 'flashcard',
    label: 'Flashcard'
  },
  {
    name: 'problem_solve_rectifier',
    label: 'Problem Solve Rectifier'
  },
  {
    name: 'image_explain',
    label: 'Image Explain'
  },
  {
    name: 'image_cyu_evaluate',
    label: 'Image CYU Evaluate'
  },
  {
    name: 'image_ask_question',
    label: 'Image Ask Question'
  }
];

const agentTypes = [
  { name: 'supervisor', label: 'Supervisor' },
  { name: 'RecommendationAgent', label: 'Recommendation Agent' },
  { name: 'ChannelsVideoAgent', label: 'Channels Video Agent' },
  { name: 'ImageQAAgent', label: 'Image QA Agent' },
  { name: 'EvaluationAgent', label: 'Evaluation Agent' },
  { name: 'MoveOnAgent', label: 'Move On Agent' },
  { name: 'HaveQuestionAgent', label: 'Have Question Agent' },
  { name: 'IMAGE_CYU_AGENT', label: 'Image CYU Agent' },
  { name: 'AUDIO_INTENT_AGENT', label: 'Audio Intent Agent' }
];

const filterByChats = [
  {
    name: 'summary',
    label: 'Summary'
  },
  {
    name: 'answer',
    label: 'Explain'
  },
  {
    name: 'quiz_mcq',
    label: 'Quiz'
  },
  {
    name: 'problem_solve',
    label: 'Problem Solve'
  },
  {
    name: 'answer_cyu_mcq',
    label: 'Answer Cyu Mcq'
  },
  {
    name: 'Content Filter (Blocked)',
    label: 'Content Filter (Blocked)'
  },
  {
    name: 'chat_intent',
    label: 'Chat Intent'
  },
  {
    name: 'chat_enrichment',
    label: 'Chat Enrichment'
  },
  {
    name: 'content_classifier',
    label: 'Content Classifier'
  },
  {
    name: 'context_identifier_user_selection',
    label: 'Content Identifier User Selection'
  },
  {
    name: 'dictionary_summary',
    label: 'Dictionary Summary'
  },
  {
    name: 'dictionary_quiz',
    label: 'Dictionary Quiz'
  },
  {
    name: 'explain_stand_alone',
    label: 'Explain Standalone'
  },
  {
    name: 'explain_suggestions',
    label: 'Explain Suggestions'
  },
  {
    name: 'expertdeck_mcq',
    label: 'Expert Deck MCQ'
  },
  {
    name: 'expertdeck_free_response',
    label: 'Expert Deck Free Response'
  },
  {
    name: 'additional_context',
    label: 'Explain (Additional Context)'
  },
  {
    name: 'citations_images',
    label: 'Explain (Citation)'
  },
  {
    name: 'flashcards',
    label: 'Flashcards'
  },
  {
    name: 'image_copilot_explain',
    label: 'Image Copilot Explain'
  },
  {
    name: 'image_copilot_answer',
    label: 'Image Copilot Answer'
  },
  {
    name: 'image_copilot_cyu',
    label: 'Image Copilot CYU'
  },
  {
    name: 'image_copilot_cyu_evaluate',
    label: 'Image Copilot CYU Evaluate'
  },
  {
    name: 'image_copilot_intent_classifier',
    label: 'Image Copilot Intent Classifier'
  },
  {
    name: 'mcq',
    label: 'Mcq'
  },
  {
    name: 'mcq_misconceptions',
    label: 'Mcq Misconceptions'
  },
  {
    name: 'mcq_skill_identifier',
    label: 'Mcq Skill Identifier'
  },
  {
    name: 'mcq_question_generation',
    label: 'Mcq Question Generation'
  },
  {
    name: 'mcq_distract',
    label: 'Mcq Distract'
  },
  {
    name: 'math_mcq_question_generation',
    label: 'Math Mcq Question Generation'
  },
  {
    name: 'math_mcq_core_concepts',
    label: 'Math Mcq Core Concepts'
  },
  {
    name: 'math_mcq',
    label: 'Math Mcq'
  },
  {
    name: 'math_mcq_validation',
    label: 'Math Mcq Validation'
  },
  {
    name: 'non_math_mcq_validation',
    label: 'Non Math Mcq Validation'
  },
  {
    name: 'generate_python',
    label: 'Problem Solve (Python)'
  },
  {
    name: 'problem_solve_rectifier',
    label: 'Problem Solve Rectifier'
  },
  {
    name: 'problem_solve_verifier',
    label: 'Problem Solve Verifier'
  },
  {
    name: 'physics_mcq',
    label: 'Physics_mcq'
  },
  {
    name: 'physics_mcq_validation',
    label: 'Physics Mcq Validation'
  },
  {
    name: 'physics_mcq_question_generation',
    label: 'Physics Mcq Question Generation'
  },
  {
    name: 'quiz_topic_practice1',
    label: 'Quiz Topic Practice1'
  },
  {
    name: 'quiz_topic_practice2',
    label: 'Quiz Topic Practice2'
  },
  {
    name: 'quiz_free_response',
    label: 'Quiz Free Response'
  },
  {
    name: 'quiz_intent',
    label: 'Quiz Intent'
  },
  {
    name: 'quiz_validate_intent',
    label: 'Quiz Validate Intent'
  },
  {
    name: 'recommendations',
    label: 'Recommendations'
  },
  {
    name: 'search_overview',
    label: 'Search Overview'
  },
  {
    name: 'summary-enrichment',
    label: 'Summary Enrichment'
  },
  {
    name: 'summary_explain',
    label: 'Summary Explain'
  },
  {
    name: 'summary_topic',
    label: 'Summary Topic'
  },
  {
    name: 'salutation',
    label: 'Salutation'
  },
  {
    name: 'summary_gpt4o',
    label: 'Summary4O'
  },
  {
    name: 'summary_gen',
    label: 'Summary Gen'
  },
  {
    name: 'topic',
    label: 'Topic'
  },
  {
    name: 'quiz',
    label: 'Topic Quiz'
  },
  {
    name: 'channel_fetch',
    label: 'Topic Generation'
  }
];

const tenantData = [
  {
    id: 0,
    tenantId: '32e81240-7457-11ed-89c4-a117ea7cad6a',
    name: 'aistudytools',
    title: 'AI Study Tools',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      },
      {
        tabUrl: 'configuration',
        tabName: 'Configuration',
        toolTipTitle: 'chatUtility.CONFIGURATION',
        permissionsRequired: ['tenant_admin', 'tenant_view']
      }
    ]
  },
  {
    id: 1,
    tenantId: 'a7167a3e-2538-4069-8f63-ef761f75b332',
    name: 'channels',
    title: 'Channels',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'configuration',
        tabName: 'Configuration',
        toolTipTitle: 'chatUtility.CONFIGURATION',
        permissionsRequired: ['tenant_admin', 'tenant_view']
      }
    ]
  },
  {
    id: 2,
    tenantId: '886a344d-54c0-4f87-82ae-3fab16af7e9e',
    name: 'pvs',
    title: 'Pearson Virtual Schools',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      },
      {
        tabUrl: 'configuration',
        tabName: 'Configuration',
        toolTipTitle: 'chatUtility.CONFIGURATION',
        permissionsRequired: ['tenant_admin', 'tenant_view']
      }
    ],
    titles: [
      {
        id: 3,
        bookId: '165733',
        title: '165733'
      },
      {
        id: 4,
        bookId: '164969',
        title: '164969'
      },
      {
        id: 5,
        bookId: '165009',
        title: '165009'
      },
      {
        id: 6,
        bookId: '165729',
        title: '165729'
      }
    ]
  },
  {
    id: 3,
    tenantId: '32e81240-7457-11e4',
    name: 'rplus',
    title: 'rplus',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabUrl: 'promptmgt',
        tabName: 'Prompt Management',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      }
    ],
    titles: [
      {
        id: 1,
        bookId: '6a1da3f5bfdd50518216847f',
        title: 'Pearson Physics 11 WA'
      },
      {
        id: 2,
        bookId: '8731852dbd490a5d5c655914',
        title: 'Pearson Mathematics 10 3rd Edition - SPDF'
      },
      {
        id: 3,
        bookId: '7000fd3164d7db154ca4bc15',
        title: 'Pearson Chemistry 11 Queensland - SPDF'
      },
      {
        id: 4,
        bookId: '60ff9a120e429e21ee07cce3',
        title: 'Heinemann Biology 1 6th Edition - EPUB'
      },
      {
        id: 5,
        bookId: '76ebbb03bd490a5d5c651b62',
        title: 'Heinemann Chemistry 2 6th Edition - EPUB'
      },
      {
        id: 6,
        bookId: '02c0adf7bbce4637a16ce2aa',
        title: 'Pearson science 7 3rd Edition'
      },
      {
        id: 7,
        bookId: 'c11d8aa88ac74be68155f484',
        title: 'WA Physics 11'
      }
    ]
  },
  {
    id: 4,
    tenantId: 'bfff63e6-3f6b-4aa9-acd8-fab7a71ee8ed',
    name: 'servicenow',
    title: 'Peri',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      }
    ],
    titles: [
      {
        id: 1,
        bookId: 'cf426e7b1bd209508f22337f034bcbe8',
        title: 'End User Technology'
      }
    ]
  },
  {
    id: 5,
    tenantId: '7b8a10a3-1326-4a16-aa92-0b82a79add01"',
    name: 'paceblueprint',
    title: 'PACE Blueprint',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      }
    ],
    titles: []
  },
  {
    id: 6,
    tenantId: '28382eac-8d80-48d5-a69c-e06603073e67',
    name: 'activehub',
    title: 'Active Hub',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      }
    ],
    titles: []
  },
  {
    id: 7,
    tenantId: '230caca0-36ff-446d-93f9-62860e3f7473',
    name: 'digitalhub',
    title: 'Digital Hub',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      },
      {
        tabUrl: 'configuration',
        tabName: 'Configuration',
        toolTipTitle: 'chatUtility.CONFIGURATION',
        permissionsRequired: ['tenant_admin', 'tenant_view']
      }
    ],
    titles: []
  },
  {
    id: 11,
    tenantId: '31dd4c5c-c5ff-4b26-94f6-45b608754e90',
    name: 'revel',
    title: 'Revel',
    tabDetails: [
      {
        tabUrl: 'auditlog',
        tabName: 'Audit Logs',
        toolTipTitle: 'chatUtility.AUDIT_LOG',
        permissionsRequired: []
      },
      {
        tabUrl: 'feedback',
        tabName: 'User Feedback',
        toolTipTitle: 'chatUtility.USER_FEEDBACK',
        permissionsRequired: []
      },
      {
        tabUrl: 'trends',
        tabName: 'Trends & Insights',
        toolTipTitle: 'chatUtility.TRENDS_INSIGHTS',
        permissionsRequired: []
      },
      {
        tabName: 'Prompt Management',
        tabUrl: 'promptmgt',
        toolTipTitle: 'chatUtility.PROMPT_MANANGEMENT',
        permissionsRequired: ['admin_can_view', 'admin_can_edit']
      },
      {
        tabUrl: 'titlesearch',
        tabName: 'Content Management',
        toolTipTitle: 'chatUtility.SUMMARY_QUIZ_MANANGEMENT',
        permissionsRequired: ['mcq_can_view', 'mcq_can_edit']
      }
    ],
    titles: []
  }
];

const groupData = [
  {
    id: 0,
    groupId: '1',
    name: 'types',
    title: 'Types'
  },
  {
    id: 1,
    groupId: '2',
    name: 'titles',
    title: 'Titles'
  }
];

const channelsTypeData = [
  {
    id: 1,
    name: 'proxy_content_filter',
    label: 'Content Filter'
  },
  // {
  //   id: 2,
  //   name: 'generate_answer_explaination',
  //   label: 'Explain'
  // },
  {
    id: 3,
    name: 'generate_question_intent',
    label: 'Generate Question Intent'
  },
  {
    id: 4,
    name: 'generate_question_explanation',
    label: 'Generate Question Explaination'
  },
  {
    id: 5,
    name: 'generate_video_summary',
    label: 'Generate Video Summary'
  },
  {
    id: 6,
    name: 'generate_topic_summary',
    label: 'Generate Topic Summary'
  },
  {
    id: 7,
    name: 'generate_question_solution',
    label: 'Generate Question Solution'
  },
  {
    id: 8,
    name: 'generate_question_steps_and_solution',
    label: 'Generate Question Steps And Solution'
  }
  // {
  //   id: 9,
  //   name: 'find_relevant_topics',
  //   label: 'Relevant Topic'
  // }
];

const reportsData = [
  {
    id: 0,
    reportsId: 'current_month',
    title: 'Current Month'
  },
  {
    id: 1,
    reportsId: 'last_month',
    title: 'Last Month'
  },
  {
    id: 2,
    reportsId: 'last_three_month',
    title: 'Last 3 Months'
  }
];

const reportsDevBookData = [
  {
    id: 0,
    bookId: 'BRNT-XUF8BS197',
    title: 'BRNT-XUF8BS197'
  },
  {
    id: 1,
    bookId: '47176bce-9894-4799-a962-e5bc835008de',
    title: '47176bce-9894-4799-a962-e5bc835008de'
  },
  {
    id: 2,
    bookId: '2NFUJ4O6CN',
    title: '2NFUJ4O6CN'
  }
];
const adminStatusData = [
  {
    id: 0,
    statusId: 'DRAFT',
    title: 'DRAFT'
  },
  {
    id: 1,
    statusId: 'EXPERIMENT',
    title: 'EXPERIMENT'
  },
  {
    id: 2,
    statusId: 'LIVE',
    title: 'LIVE'
  },
  {
    id: 3,
    statusId: 'ARCHIVED',
    title: 'ARCHIVED'
  }
];

const AdminPromptProperties = [
  {
    id: 'temperature',
    sliderLable: 'Temperature',
    minVal: 0,
    maxVal: 100,
    step: 0.1,
    value: 0
  },
  {
    id: 'max_tokens',
    sliderLable: 'Maximum Tokens',
    minVal: 0,
    maxVal: 5000,
    step: 1,
    value: 0
  },
  {
    id: 'top_p',
    sliderLable: 'Top P',
    minVal: 0,
    maxVal: 100,
    step: 0.1,
    value: 0
  },
  {
    id: 'frequency_penalty',
    sliderLable: 'Frequency Penalty',
    minVal: 0,
    maxVal: 100,
    step: 0.1,
    value: 0
  },
  {
    id: 'presence_penalty',
    sliderLable: 'Presence Penalty',
    minVal: 0,
    maxVal: 100,
    step: 0.1,
    value: 0
  }
];

const TabList = {
  AUDIT_LOG: 'auditlog',
  FEEDBACK: 'feedback',
  TRENDS: 'trends',
  PROMPT: 'promptmgt',
  CONTENT_MGMT: 'titlesearch',
  CONFIGURATION: 'configuration'
};

const ChatgptConfig = {
  feedBackTypesDropdownList,
  chatData,
  filterByChats,
  tenantData,
  channelsTypeData,
  groupData,
  reportsData,
  reportsDevBookData,
  adminStatusData,
  AdminPromptProperties,
  TabList,
  agentTypes
};

module.exports = ChatgptConfig;
